// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 885 ? "remind" : chunkId) + "." + {"10":"786fa020","885":"786fa020"}[chunkId] + ".css";
};